import React , {useEffect} from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import './HeroAreaExplore.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Aos from 'aos';
import "aos/dist/aos.css";


const HeroAreaExplore = () => {

  
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
  
        <div className={`${className} sliding_arrow`}  
        
        onClick={onClick}  >
        <img src="/images/icons/right-arrow-black.png" alt="" />
      </div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={`${className} sliding_arrow`}  
     
      onClick={onClick}  >
      <img src="/images/icons/left-arrow-black.png" alt="" />
    </div>
    );
  }


  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    speed: 500,
    autoplaySpeed: 1250,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    cssEase: "linear",
  };

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);

  
  return (
    <div className="hero_explore_slider">

 <Slider {...settings}>
 

 <div className="explore_single_div explroe_hero_1" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"   >

    <div className="content_top_explore">
    <h1 className="heroarea_subheadline"> ألاصالة السعودية </h1>
    <div className="underline_line_thick"></div>
    </div>



<div className="mt-3 explore_content_area ">
 
    <div className="d-flex f-sp f-wrap hero_sliding_div ">

    <div className='content_info' >
    <h1 className="heroarea_headline" > التسوق في السعودية </h1>
    <p className="main_para mt-1 color-white"> أكتشف افضل اماكن التسوق في السعودية وجرب معنا تجربة جديدة </p>
    
    <button className="btn_category mt-2 w-50 bg_green"> أكتشف أكثر </button>
    </div>

    {/* <div className='content_img' >
        <img src="https://images.unsplash.com/photo-1520434087499-0fa48ffb40c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" alt="" className="rectable_img_explore" data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />

        <img src="https://cdn.pixabay.com/photo/2012/11/28/11/56/caravan-67758_960_720.jpg" alt="" className="rectable_img_explore" data-aos-duration="420" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />
    </div> */}

    </div>

   

</div>
</div>

 <div className="explore_single_div explroe_hero_2" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"  >

    <div className="content_top_explore" >
    <h1 className="heroarea_subheadline"> ألاصالة السعودية </h1>
    <div className="underline_line_thick"></div>
    </div>



<div className="explore_content_area ">
 
    <div className="d-flex f-sp f-wrap hero_sliding_div ">

    <div className='content_info' >
    <h1 className="heroarea_headline"> الترفيه في السعودية </h1>
    <p className="main_para mt-1 color-white">  جرب كل يوم شئ جديد وفعالية جديدة عن طريق ابرز معالم الترفيه في موقعنا </p>
    
    <button className="btn_category mt-2 w-50 bg_green"> أكتشف أكثر </button>
    </div>

    {/* <div className='content_img' >
        <img src="https://images.unsplash.com/photo-1521478185088-44d79b3fe964?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="" className="rectable_img_explore" data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />

        <img src="https://images.unsplash.com/photo-1579675540378-bb48b4981513?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80" alt="" className="rectable_img_explore" data-aos-duration="420" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />
    </div> */}

    </div>

   

</div>
</div>

 <div className="explore_single_div explroe_hero_3" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"  >

    <div className="content_top_explore">
    <h1 className="heroarea_subheadline">     الأصالة السعودية </h1>
    <div className="underline_line_thick"></div>
    </div>



<div className="explore_content_area ">
 
    <div className="d-flex f-sp f-wrap hero_sliding_div ">

    <div className='content_info' >
    <h1 className="heroarea_headline">   عيش أجمل اللحظات مع عيلتك  </h1>
    <p className="main_para mt-1 color-white"> أكتشف افضل اماكن التسوق في السعودية وجرب معنا تجربة جديدة </p>
    
    <button className="btn_category mt-2 w-50 bg_green"> أكتشف أكثر </button>
    </div>

    {/* <div className='content_img' >
        <img src="https://images.unsplash.com/photo-1590959914819-b767b9fe4cfb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="" className="rectable_img_explore" data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />

        <img src="https://images.unsplash.com/photo-1611223995703-1a1f6d9ebbc1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" alt="" className="rectable_img_explore" data-aos-duration="420" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" />
    </div> */}

    </div>

   

</div>
</div>





</Slider>
 

  

  



  
    </div>
  )
}

export default HeroAreaExplore